/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Spanish (International)
export default {
  'townsquare.townsquare-tags.tag': 'Eliminar etiqueta',
  'townsquare.townsquare-tags.tooltip-usage-count':
    '{usageCount, plural, one {En uso en {usageCount,number} lugar} other {En uso en {usageCount,number} lugares}}',
};
